// extracted by mini-css-extract-plugin
export default {"programBlock":"ProgramBlock_programBlock__eDCF-","heading":"ProgramBlock_heading__PrX0-","richText":"ProgramBlock_richText__NrhQq"};